/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, {useEffect, useState } from "react";
import {
  MdDelete,
  MdKeyboardArrowRight,
  MdOutlineModeEdit,
  MdSearch,
} from "react-icons/md";
import { BiHomeAlt } from "react-icons/bi";
import Header from "../../../../Components/Dashboard/Header/Header";
import Sidebar from "../../../../Components/Dashboard/Sidebar/Sidebar";
import Loader from "../../../../Components/loader/loader";
import { useNavigate } from "react-router-dom";
import { FiDownload } from "react-icons/fi";
import "../ResumeDisplay/ResumeDisplay.css";
import { Apiurl, GetToken } from "../../../../Utils/utils";
import axios from "axios";
import { toast } from "react-toastify";
import { Button, Modal, Offcanvas } from "react-bootstrap";
import Select from "react-select";
import { IoIosFunnel } from "react-icons/io";

function OffCanvasExample({ setShowResumeFilter, showResumeFilter , departmentData ,FilterData,expreinceeuserData,handleUserExperiences,handleDepartmentChange ,name, ...props }) {

  const handleClose = () => setShowResumeFilter(false);
  const handleShow = () => setShowResumeFilter(true);

  return (
    <>
      <Button className="HideButton-onResumeDisplay-screen" variant="primary" onClick={handleShow} >
      <IoIosFunnel />
      </Button>
      <Offcanvas className="Offcanvas-main-container" show={showResumeFilter} onHide={handleClose} {...props}>
        <Offcanvas.Header className="Offcanvas-outter-container" closeButton>
          <Offcanvas.Title>Resume Data</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="Offcanvas-Body-container">
          <div className="Offcanvas-inner-container">
        <div className="Offcanvas-resume-filter-close" onClick={handleClose}></div>
          </div>
        <div className="Search-Filter-of-userCv-data-table-for-mobile">
                    <Select
                      classNamePrefix="search-Filter-Category"
                      placeholder="Category"
                      options={departmentData}
                      getOptionLabel={(options) => options?.label}
                      getOptionValue={(options) => options?.value}
                      value={
                        FilterData?.UserRole?.RoleName === "HR"
                          ? departmentData.find(
                              (department) => department.label === "Management"
                            )
                          : FilterData?.Department
                      }
                      onChange={handleDepartmentChange}
                    />
                  </div>
                  <div className="Search-Filter-of-userCv-data-table-expreinceeuserData-for-mobile">
                    <Select
                      classNamePrefix="search-Filter-Category"
                      placeholder="Experience "
                      options={expreinceeuserData}
                      getOptionLabel={(options) => options?.Name}
                      getOptionValue={(options) => options?.Id}
                      onChange={handleUserExperiences}
                    />
                  </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

const ResumeDisplay = () => {
  const [loading, setLoading] = useState(false);
  const [showResumeFilter, setShowResumeFilter] = useState(false);

  const navigate = useNavigate();
  const [showSidebar, setShowSidebar] = useState(true);
  const [showImageModal, setShowImageModal] = useState(false);
  const LoginToken = GetToken();
  const [cvAllData, setCVAllData] = useState([]);
  const [deleteItem, setDeleteItem] = useState(null);
  const [departmentData, setDepartmentData] = useState([]);

  const [handelSearchData, setHandelSearchData] = useState("");
  const [expreinceeuserData, setExpreinceeuserData] = useState("");

  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState();
  const [AllNumbers,setAllNumbers]=useState([])
const [PageCount,setPageCount]=useState(1)
  const [FilterData, setFilterData] = useState({
    Category: "",
    Experience: "",
  });
  const handleClose = () => setShowImageModal(false);
  // const handleShow = () => setShowImageModal(true);  

  useEffect(() => {
    const timer = setTimeout(() => {
      handleResumeDisplay();
    }, 1000);
    return () => clearTimeout(timer);
  }, [FilterData]); 

 
   
  const handleOpenModal = (item) => {
    setDeleteItem(item);
    setShowImageModal(true);
  };
   const scrollToTop = () => {
    document.getElementById("scroller").scroll(0,0)
  }
  const handleResumeDisplay = (e) => {
    setLoading(true);

    const data = {};
    data.Experience = FilterData?.Experience;
    data.Category = FilterData?.Category;
    // for change page no 
    data.pageNo = PageCount;
    data.pageSize = pageSize.toString(); 


    const option = {
      method: "POST",
      headers: {    
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },

      url: `${Apiurl()}/Cv/FilterCvList`,

      data: { data: JSON.stringify(data) },
    };

    axios(option)
      .then((e) => {
        setLoading(false);
        if (e?.status === 200) {
          toast.success(e?.data?.message);
          const responceData = e?.data?.filteredCvs;
          const pageCount = e?.data.totalPageCount;
          setCurrentPage(pageCount)
          setCVAllData(responceData);
          scrollToTop()
          setShowResumeFilter(false)

              }
      })
      .catch((error) => {
        
        setLoading(false);
      });                                                                 
  };

  useEffect(() => {
    handleResumeDisplay();
  }, [PageCount]);

    

  // delete userdata Api
  const handleDeleteResume = (deleteItem) => {
    
    const data = {};
    data.Id = deleteItem.id;
    setLoading(true);
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*", 
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Cv/DeleteCV`,


      data: { data: JSON.stringify(data) },
    };
    axios(option)
      .then((e) => {
        setShowImageModal(false);
        setLoading(false);
        if (e?.status === 200) {
          toast.success(e?.data?.message);
          handleResumeDisplay();
        }
      })
      .catch((error) => {
        setShowImageModal(false);
        setLoading(false);
      });
  };
  // send prefiled data
  const handelEditTableData = (item) => {
    navigate("/Emp/ResumeUpload", { state: item });
  };
  useEffect(() => {
    const timer = setTimeout(() => {
      handleResumeDisplay();
    }, 1000);
    return () => clearTimeout(timer);
  }, [handelSearchData]);

  const getDepartment = () => {
    setLoading(true);
    const token = GetToken();
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      url: `${Apiurl()}/Admin/GetDepartments`,
    };
    axios(option)
      .then((e) => {
        setLoading(false);
        const data = JSON.parse(e?.data?.data);
        const finalData = data?.map((item) => ({
          label: item?.Name,
          value: item?.Id,
        }));
        setDepartmentData(finalData);
      })
      .catch((err) => {
        setLoading(false);
      });
  };
  useEffect(() => {
    getDepartment();
  }, []);

  const handleDepartmentChange = (selectedOption) => {
    setFilterData({ ...FilterData, Category: selectedOption?.value });
  };
  const handleUserExperiences = (selectedOption) => {
    setFilterData({ ...FilterData, Experience: selectedOption?.Id });
  };
  const GetUserExperiences = () => {
    setLoading(true);
    const token = GetToken();
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },

      url: `${Apiurl()}/Cv/GetExperiences`,

    };
    axios(option)
      .then((e) => {
        setLoading(false);
        const data = JSON.parse(e?.data?.data);
        setExpreinceeuserData(data.Result);
      })
      .catch((err) => {
      
        setLoading(false);
      });
  };
  useEffect(() => {
    GetUserExperiences();
  }, []);

  const handleDataSearch = (e) => {
    const searchTerm = e?.target?.value?.toLowerCase();
    if (searchTerm) {
      const filteredData = cvAllData?.filter((item) => {
        return item?.name?.toLowerCase()?.includes(searchTerm);
      });
      setCVAllData(filteredData);
    } else {
      handleResumeDisplay();
    }
  };
  const downloadFile = async (FileDownloadUrl) => {
    try {
      const response = await fetch(FileDownloadUrl);
      const blob = await response.blob();

      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      const fileName = FileDownloadUrl.substring(
        FileDownloadUrl.lastIndexOf("/") + 1
      );
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      // console.error("Error downloading the file:", error);
    }
  };

  const check = (item) => {
    const NewFile = item.FileDownloadUrl;
    downloadFile(NewFile);
  };

  const handleDownload = (fileUrl, fileName) => {
    const pdfUrl = fileUrl;
        const link = document.createElement("a");
        link.href = pdfUrl;
        link.download = "document.pdf";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    
  };

  useEffect(() => {
    if (currentPage) {
      const pages = Math.ceil(currentPage);
      const arrNumber = Array.from({ length: pages }, (_, i) => i + 1);
      setAllNumbers(arrNumber);
    }
  }, [currentPage]);
  return (
    <>
      {loading ? <Loader /> : null}
      <Header showSidebar={showSidebar} setShowSidebar={setShowSidebar} />
      <div className="d-flex">  
        <Sidebar showSidebar={showSidebar} />
        <>
          <div
            className={
              showSidebar 
                ? "EMP-main-container-of-all-employees-sheet-hr"
                : "EMP-main-container-of-all-employees-page-new-sheet"
            }
          >
            <div className="resume-alldata-heading-section">
              <div>
                <p className="MAIN-HEADING">
                  Resume Data
                </p>
              </div>
              <div className="dashboiard-inner-header">
                <BiHomeAlt className="EMP-home-icon-header-inn" />
                <MdKeyboardArrowRight className="hide-button-on-mobile" />
                <p> Resume Data </p>
                <MdKeyboardArrowRight  className="hide-button-on-mobile"  />
                <p>Resume Data</p>
              <OffCanvasExample showResumeFilter={showResumeFilter} setShowResumeFilter={setShowResumeFilter} 
              departmentData={departmentData} FilterData={FilterData}  handleDepartmentChange={handleDepartmentChange}
              expreinceeuserData={expreinceeuserData} handleUserExperiences={handleUserExperiences}
            placement="bottom" name="Open Bottom" />
              </div>
            </div>
            <div className="EMP-body-part-outer-container">
              <div className="EMP-inner-body-container-of-employee-table row-12">
                <div className="Resume-display-table-header">
                  <div className="EMP-employee-text-in-body">
                    <h2>Resume Data</h2>
                  </div>
         
                  <div className="coustom-search-data">
                    <MdSearch className="EMP-search-icon-in-input" />
                    <input
                      type="text"
                      placeholder="Search"
                      onChange={(e) => handleDataSearch(e)}
                    />
                  </div>
  
                  <div className="Search-Filter-of-userCv-data-table">
                    <Select
                      classNamePrefix="search-Filter-Category"
                      placeholder="Category"
                      options={departmentData}
                      getOptionLabel={(options) => options?.label}
                      getOptionValue={(options) => options?.value}
                      value={
                        FilterData?.UserRole?.RoleName === "HR"
                          ? departmentData.find(
                              (department) => department.label === "Management"
                            )
                          : FilterData?.Department
                      }
                      onChange={handleDepartmentChange}
                    />
                  </div>
                  <div className="Search-Filter-of-userCv-data-table-expreinceeuserData">
                    <Select
                      classNamePrefix="search-Filter-Category"
                      placeholder="Experience "
                      options={expreinceeuserData}
                      getOptionLabel={(options) => options?.Name}
                      getOptionValue={(options) => options?.Id}
                      onChange={handleUserExperiences}
                    />
                  </div>
                </div>
              </div>
              <div className="main-class-for-table-in-admin-resume-data-sreen" id="scroller">
                <table className="resume-display-table" >
                  <thead className="thead-of-emp-table-leaves">
                    <tr className="">
                      <th className="approve_Date-display"> Sr. no</th>
                      <th className="approve_Date-display"> Name</th>
                      <th className="approve_Date-display">Phone</th>
                      <th className="approve_Date-display">Email</th>
                      <th className="approve_Date-display">Category</th>
                      <th className="approve_Date-display">Sub-Category</th>
                      <th className="approve_Date-display">Experience</th>
                      <th className="approve_Date-display">Skills</th>
                      <th className="approve_Date-display">CV</th>
                      <th className="approve_Date-display">Actions</th>
                    </tr>
                  </thead>
                  <tbody className="tbody-ofemp-table-leaves">
                    {cvAllData?.map((item, index) => (
                      <tr key={index}>
                        <td> {index + 1}</td>
                        <td>{item?.name}</td>
                        <td>{item?.phone}</td>
                        <td>{item?.email}</td>
                        <td>{item?.categories?.name}</td>
                        <td>{item?.subCategories?.designationName}</td>
                        <td>{item?.experiences?.name}</td>
                        <td>{item?.skills}</td>
                        <td
                          className="slip-downloard"
                          onClick={() =>
                            handleDownload(item?.fileDownloadUrl, "cv.pdf")
                          }
                        >
                          <span className="Downloard-cv-icon">
                            <FiDownload />
                          </span>
                        </td>
                        <td className="Resume-display-action-buttons">
                          <MdOutlineModeEdit
                            onClick={() => handelEditTableData(item)}
                            className="handel-Edit-button"
                          />
                          <MdDelete
                            className="handel-delete-button"
                            onClick={() => handleOpenModal(item)}
                          />
                        </td>
                      </tr>
                      
                    ))}
         
                  </tbody>

                </table>
                  {cvAllData.length ?
                  <div className="AllPage_number-flex-container">

                  {AllNumbers?.map(page => (
                    <div key={page} className="AllPage-numbes-containes">
        <button className={PageCount === page ? "change-color-of-Number":"defaultcolor"} onClick={()=>setPageCount(page)} >
          {page}
        </button>
          </div>
      ))}
      </div> : null
                  }
             
              </div>
            </div>
          </div>
        </>
      </div>
      <Modal show={showImageModal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title> Delete Resume Data</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {deleteItem && (
            <div>
              <p>Name: {deleteItem?.name}</p>
              <p>Phone: {deleteItem?.phone}</p>
              <p>Email: {deleteItem?.email}</p>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button className="close_button-of-Resume" onClick={handleClose}>
            Close
          </Button>
          <Button
            className="DeleteButton-ofResume"
            onClick={() => handleDeleteResume(deleteItem)}
          >
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default ResumeDisplay;
